<template>
  <v-dialog v-model="dialog" max-width="800px" persistent>
    <v-card>
      <v-card-title>
        <span class="headline">Editar Clientes do Grupo</span>
      </v-card-title>
      <v-card-text>
        <EconomicGroupSelectClients 
          ref="form" 
          :economic_group="model_economic_group" 
          :set_clients="true"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <f-btn close @click="closeDialog"></f-btn>
        <f-btn save @click="save" :loading="loading"></f-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Api from '@/api/index';

export default {
  name: 'DialogEditEconomicGroupClients',
  props: {
    dialog: {
      type: Boolean,
      required: true
    },
    model_economic_group: {
      type: Object,
      required: true
    }
  },
  components: {
    EconomicGroupSelectClients: () => import('@/_backoffice/_registrations/components/economic_groups/forms/EconomicGroupSelectClients.vue'),
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog')
    },
    save() {
      if (!(this.model_economic_group.client_ids && this.model_economic_group.client_ids.length >= 2)) {
        this.$toast && this.$toast.error('Selecione ao menos 2 clientes')
        return
      }
      
      this.loading = true
      Api.EconomicGroup.update(this.model_economic_group).then(() => {
        this.successSaved()
        this.$emit('updated')
      }).catch(() => {
        this.errorUpdated()
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

